import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, Navigate, Outlet } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Artists from "./pages/Artists";
import Highlights from "./pages/Highlights";
import Contact from "./pages/Contact";
import Shop from "./pages/Shop";
import AdminOrders from "./pages/AdminOrders";
import Checkout from "./pages/Checkout";
import { siteContent } from "./content";

const routeMeta = {
  "/": {
    title: "Sasmita & Sangram | Playback Singers & Live Performers",
    description:
      "Official website of Sasmita & Sangram — playback singers, Facebook Live stars, and concert performers. Book for live shows and events in India and abroad."
  },
  "/artists": {
    title: "Artists | Sasmita & Sangram",
    description: "Meet Sasmita Biswal and Sangram Mohanty — playback singers and viral live performers."
  },
  "/highlights": {
    title: "Highlights | Sasmita & Sangram",
    description: "Career highlights, awards, and major concerts by Sasmita & Sangram across India and abroad."
  },
  "/contact": {
    title: "Contact & Booking | Sasmita & Sangram",
    description:
      "Bookings and enquiries for concerts, playback singing, and virtual shows. WhatsApp and email for Sasmita & Sangram."
  },
  "/shop": {
    title: "Shop | Sasmita & Sangram",
    description: "Order official merchandise and music specials from Sasmita & Sangram."
  },
  "/checkout": {
    title: "Checkout | Sasmita & Sangram",
    description: "Review cart items and enter delivery details."
  },
  "/admin/orders": {
    title: "Admin Orders | Sasmita & Sangram",
    description: "Admin view of recent orders."
  }
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
};

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const metaKey = location.pathname.startsWith("/shop/") ? "/shop" : location.pathname;
    const meta = routeMeta[metaKey] || routeMeta["/"];
    if (meta?.title) document.title = meta.title;
    if (meta?.description) {
      let descTag = document.querySelector('meta[name="description"]');
      if (!descTag) {
        descTag = document.createElement("meta");
        descTag.name = "description";
        document.head.appendChild(descTag);
      }
      descTag.setAttribute("content", meta.description);
    }
  }, [location.pathname]);

  const handleNavigate = (path) => navigate(path);

  return (
    <div className="app-shell min-h-screen text-white">
      <ScrollToTop />
      <Navbar onNavigate={handleNavigate} currentPath={location.pathname} />
      <main className="pb-20">
        <Outlet context={{ onNavigate: handleNavigate }} />
      </main>
      <Footer contact={siteContent.contact} socials={siteContent.socials} />
    </div>
  );
};

const PageWithNav = ({ Component }) => {
  const navigate = useNavigate();
  return <Component onNavigate={(path) => navigate(path)} />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<PageWithNav Component={Home} />} />
          <Route path="/artists" element={<PageWithNav Component={Artists} />} />
          <Route path="/highlights" element={<PageWithNav Component={Highlights} />} />
          <Route path="/contact" element={<PageWithNav Component={Contact} />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:productSlug" element={<Shop />} />
          <Route path="/checkout" element={<PageWithNav Component={Checkout} />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
